<ng-container
	*ngIf="{
		userData: myAccountData$ | async,
		license: license$ | async,
		showHomeLink: showHomeLink$ | async,
		isSubscriptionLicenseType: isSubscriptionLicenseType$ | async,
		isLicenseNotSet: isLicenseNotSet$ | async,
		isLecturerRole: isLecturerRole$ | async,
		isLicenseCanceledOrInactive: isLicenseCanceledOrInactive$ | async,
		billingPortalUrl: billingPortalUrl$ | async,
		devices: devices$ | async,
		canUseDevices: canUseDevices$ | async,
	} as viewData"
>
	<div class="my-account-wrapper" *ngIf="viewData.userData; else loader">
		<div class="title-wrapper">
			<h2 class="sf">{{ 'sf.shared_component.my_account.title' | translate }}</h2>
		</div>
		<div class="card settings-wrapper">
			<!-- Pricing plan-->
			<div class="plan-title-header">
				<h4 class="sf section-title">
					{{ 'sf.shared_component.my_account.pricing_plan.title' | translate }}
				</h4>
				<span *ngIf="viewData.showHomeLink" class="link" (click)="navigateToHome()">{{
					'sf.shared_component.my_account.back_to_home' | translate
				}}</span>
			</div>
			<div id="plan-data" class="section">
				<div class="general-info">
					<div class="icon-wrapper">
						<mat-icon [svgIcon]="viewData.license.licenseType | planIcon"></mat-icon>
						<mat-icon
							*ngIf="!userActive"
							class="lock-icon"
							[matTooltip]="'sf.module.dashboard.nutrition_dashboard.account_inactive.title' | translate"
							>lock</mat-icon
						>
					</div>
					<div class="name-wrapper">
						<div class="plan-title">
							{{ 'sf.shared_component.my_account.pricing_plan.general_info.selected_plan' | translate }}
							{{ 'sf.payment.details.license_type.' + viewData.license.licenseType | translate }}
						</div>
						<sf-user-license-info-limits
							*ngIf="!viewData.isLicenseNotSet && !viewData.isLecturerRole"
							[farmsLimit]="viewData.userData.farmsLimit"
							[rationsLimit]="viewData.userData.rationsLimit"
						></sf-user-license-info-limits>
					</div>
				</div>

				<div class="blocks-wrapper" *ngIf="viewData.license.subscription as subscription">
					<div class="license-info white-box">
						<span class="caption">{{ 'sf.shared_component.my_account.pricing_plan.license.title' | translate }}</span>

						<span *ngIf="viewData.isSubscriptionLicenseType && !!subscription && subscription.interval">
							{{ 'sf.shared_component.my_account.pricing_plan.license.subscription' | translate }}
							<strong>{{ 'sf.common.subscription_type.' + subscription.interval | translate }}</strong>
						</span>
						<span>
							{{ 'sf.shared_component.my_account.pricing_plan.license.license_status' | translate }}
							<strong>{{ 'sf.payment.details.license_status.' + viewData.license.licenseStatus | translate }}</strong>
						</span>
						<span *ngIf="viewData.isSubscriptionLicenseType && viewData.license.licenseStatus === LicenseStatus.ACTIVE">
							{{ 'sf.shared_component.my_account.pricing_plan.license.renewal_date' | translate }}
							<strong>{{ subscription.endsAt | localizedDate }}</strong>
						</span>

						<ng-container *ngIf="viewData.isSubscriptionLicenseType; else noSubscriptionLicenseValidTime">
							<span *ngIf="viewData.isLicenseCanceledOrInactive">
								{{ 'sf.shared_component.my_account.pricing_plan.license.expiration_date' | translate }}
								<strong>{{ subscription.endsAt | localizedDate }}</strong>
							</span>
						</ng-container>

						<ng-template #noSubscriptionLicenseValidTime>
							<span>
								<span *ngIf="viewData.userData.activationDate || viewData.userData.expirationDate">{{
									'sf.shared_component.my_account.pricing_plan.license.license_active' | translate
								}}</span>
								<span *ngIf="viewData.userData.activationDate">
									{{ 'sf.shared_component.my_account.pricing_plan.license.license_active_from' | translate }}
									<strong>{{ viewData.userData.activationDate | localizedDate }}</strong>
								</span>
								<span *ngIf="viewData.userData.expirationDate">
									{{ 'sf.shared_component.my_account.pricing_plan.license.license_active_to' | translate }}
									<strong>{{ viewData.userData.expirationDate | localizedDate }}</strong>
								</span>
							</span>
						</ng-template>
					</div>
				</div>

				<a *ngIf="viewData.billingPortalUrl" class="link" target="_blank" href="{{ viewData.billingPortalUrl }}">
					{{ 'sf.shared_component.my_account.pricing_plan.manage_my_subscription' | translate }}
				</a>
			</div>

			<!-- User data section -->
			<ng-container *ngIf="!viewData.isLicenseNotSet">
				<h4 class="sf section-title">{{ 'sf.shared_component.my_account.user_data.title' | translate }}</h4>
				<div id="user-data" class="section">
					<div class="box">
						<span class="box-title">
							{{ 'sf.shared_component.my_account.user_data.buyer' | translate }}
						</span>
						<ng-container *ngIf="viewData.userData.personalAddress">
							<ng-container
								*ngTemplateOutlet="userDataDetails; context: { data: viewData.userData.personalAddress }"
							></ng-container>
						</ng-container>

						<div class="action-wrapper">
							<span class="link" (click)="onEditDataClick(UserDataType.PersonalData)">
								{{ 'sf.shared_component.my_account.user_data.edit_data' | translate }}
							</span>
						</div>
					</div>
					<div *ngIf="personalAddressData" class="box">
						<span class="box-title">
							{{ 'sf.shared_component.my_account.user_data.billing' | translate }}
						</span>
						<ng-container *ngIf="viewData.userData.personalAddress">
							<ng-container
								*ngTemplateOutlet="
									userDataDetails;
									context: {
										data: viewData.userData.invoiceAddress
											? viewData.userData.invoiceAddress
											: viewData.userData.personalAddress,
									}
								"
							></ng-container>
						</ng-container>

						<div class="action-wrapper">
							<span class="link" (click)="onEditDataClick(UserDataType.InvoiceData)">
								{{ 'sf.shared_component.my_account.user_data.edit_data' | translate }}
							</span>
						</div>
					</div>
					<ng-template #userDataDetails let-data="data">
						<div class="data-wrapper">
							<span *ngIf="data.customerType === CustomerType.INDIVIDUAL"
								>{{ data.firstName }} {{ data.lastName }}</span
							>
							<span *ngIf="data.customerType === CustomerType.COMPANY">{{ data.company }}</span>
							<span>{{ data.address }}</span>
							<span>{{ data.postCode }} {{ data.city }}, {{ data.countryCode | countryName | async }}</span>
							<br />
							<span class="phone"
								>{{ 'sf.shared_component.my_account.user_data.user_data_form.phone' | translate }}:
								{{ resolvePrefix(data.countryCode) }} {{ data.phone }}</span
							>
							<br />
							<span class="customer-type"
								>{{ 'sf.shared_component.my_account.user_data.user_data_form.customer_type' | translate }}:
								{{ 'sf.common.customer_type.' + data.customerType | translate }}</span
							>
							<span *ngIf="data.customerType === CustomerType.INDIVIDUAL"
								>{{ 'sf.shared_component.my_account.user_data.user_data_form.personal_id' | translate }}:
								{{ data.personalIdNumber }}</span
							>
							<span *ngIf="data.customerType === CustomerType.COMPANY"
								>{{ 'sf.shared_component.my_account.user_data.user_data_form.vat_number' | translate }}:
								{{ data.vatNumber }}</span
							>
						</div>
					</ng-template>
				</div></ng-container
			>

			<!-- Security section -->
			<h4 class="sf section-title">{{ 'sf.shared_component.my_account.security_section.title' | translate }}</h4>
			<div id="security" class="section">
				<div class="section-sub-title">
					{{ 'sf.shared_component.my_account.security_section.password' | translate }}
				</div>
				<span class="link" (click)="onChangePasswordClick()">{{
					'sf.shared_component.my_account.security_section.change_password' | translate
				}}</span>
			</div>

			<!-- Devices section -->
			<ng-container *ngIf="viewData.canUseDevices">
				<div class="plan-title-header">
					<h4 class="sf section-title">{{ 'sf.shared_component.my_account.devices_section.title' | translate }}</h4>
					<span class="link" [class.disabled]="addDeviceInProgress" (click)="onAddDeviceClick()">
						<mat-spinner *ngIf="addDeviceInProgress; else addDeviceLabel" [diameter]="14" color="accent"></mat-spinner>
						<ng-template #addDeviceLabel>{{
							'sf.shared_component.my_account.devices_section.add_device' | translate
						}}</ng-template>
					</span>
				</div>
				<div id="devices" class="section">
					<sf-my-account-devices-list
						[devices]="viewData.devices"
						(changed)="onDevicesChanged()"
					></sf-my-account-devices-list>
				</div>
			</ng-container>
		</div>
	</div>
</ng-container>

<ng-template #loader>
	<div class="loader">
		<mat-spinner color="accent" [diameter]="80"></mat-spinner>
	</div>
</ng-template>
